import { render, staticRenderFns } from "./HelpPopup.vue?vue&type=template&id=031d644b&scoped=true&lang=pug&"
import script from "./HelpPopup.vue?vue&type=script&lang=js&"
export * from "./HelpPopup.vue?vue&type=script&lang=js&"
import style0 from "./HelpPopup.vue?vue&type=style&index=0&id=031d644b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d644b",
  null
  
)

export default component.exports